var React = require('react');

function DifficultyLevelBlue (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#4A90E2"},React.createElement("rect",{"x":"0","y":"0","width":"21","height":"21"}))));
}

DifficultyLevelBlue.defaultProps = {"viewBox":"0 0 21 21","version":"1.1"};

module.exports = DifficultyLevelBlue;

DifficultyLevelBlue.default = DifficultyLevelBlue;
